import React, { Suspense, lazy } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import PrivateRoute from "./components/PrivateRoute";
import configureStore from "./configureStore";
import Login from "./pages/LoginPage";
import {
  AGENCY_ROLE,
  INTERPRETER_ROLE,
  REQUESTER_ROLE,
} from "./constants/global";
import HostCheck from "./HostCheck";
import Diverter from "./Diverter";
import NotFound from "./pages/404";
import Loading from "./pages/FullPageLoading";
import Rating from "./pages/Ratings/RequesterRating";

import "./assets/scss/main.scss";

const AgencyApp = lazy(() => import("./apps/agency"));
const InterpreterApp = lazy(() => import("./apps/intepreter"));
const RequesterApp = lazy(() => import("./apps/requester"));
const VideoAppointmentApp = lazy(() => import("./apps/video-appointment"));

const store = configureStore();

const Root = () => (
  <Provider store={store}>
    <HostCheck>
      <Router>
        <Suspense fallback={<Loading />}>
          <Switch>
            {process.env.NODE_ENV === "development" ? (
              // Use this for testing short-lived component,
              // e.g. modal windows, Loading Page, etc
              // replace null with any component you are developing
              <Route exact path="/dev-test" component={Loading} />
            ) : null}
            <Route exact path="/login" component={Login} />
            <PrivateRoute
              path="/agency"
              userRole={AGENCY_ROLE}
              component={AgencyApp}
            />
            <PrivateRoute
              path="/interpreter"
              userRole={INTERPRETER_ROLE}
              component={InterpreterApp}
            />
            <PrivateRoute
              path="/requester"
              userRole={REQUESTER_ROLE}
              component={RequesterApp}
            />
            <Route path="/video-appt" component={VideoAppointmentApp} />
            <PrivateRoute exact path="/" component={Diverter} />
            <Route component={NotFound} />
          </Switch>
        </Suspense>
      </Router>
    </HostCheck>
  </Provider>
);

export default Root;
